<template>
    <div v-if="loaded">
      <flash-message></flash-message>
    </div>
</template>
<script>
import { verifyIfDriveHasAlreadyInitialized, getJWTToken } from '@/common/driveserver';
import store from '../../common/store';

export default {
  name: 'DriveInit',
  data: () => ({
    loaded: false,
  }),
  async created() {
    const path = '';
    await getJWTToken()
      .then((response) => {
        if (response && response.data) {
          store.saveToken(response.data.token);
        }
      }).finally(() => {
        this.loaded = true;
      });

    await verifyIfDriveHasAlreadyInitialized()
      .then((response) => {
        if (response.data) {
          this.$router.push({
            name: 'access-permission',
            params: { path },
          });
        } else {
          this.$router.push({
            name: 'init',
          });
        }
      })
      .catch(() => {
        this.flash('Ocorreu um erro carregar', 'error', { timeout: 5000 });
      });
  },
};
</script>
